module.exports = __webpack_public_path__ + "img/95.3c6bf7a0.jpg";